import React, { useState } from 'react';

import { MdSearch } from 'react-icons/md';

const SearchableDropdown = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const items = ['React js', 'Ui Ux design', 'Node Js', 'Flutter', 'Dot.Net'];

  const filteredItems = items.filter(item => 
    item.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="w-full max-w-xs mx-auto">
      <div className="relative">
        <div className="absolute inset-y-0 left-0 flex items-center pl-3">
          <MdSearch className="h-5 w-5 text-gray-400" />
        </div>
        <input
          type="text"
          placeholder="Search by name"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full pl-10 pr-4 py-2 rounded-md border border-black focus:outline-none focus:border-blue-500"
        />
      </div>
      <ul className="mt-2 bg-white border border-gray-300 rounded-md shadow-lg">
        {filteredItems.map((item, index) => (
          <li key={index} className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SearchableDropdown;
